export default function MentionElement({ attributes, children, element }) {
  return (
    <span
      {...attributes}
      contentEditable={false}
      data-userid={element.userId}
      title={element.name}
      style={{
        display: "inline-block",
        padding: "2px 8px",
        margin: "0 2px",
        background: "#e6f0ff",
        borderRadius: 6,
        border: "1px solid #cfe3ff",
        fontWeight: 600,
        color: "#1d4ed8"
      }}
    >
      @{element.name}
      {children}
    </span>
  );
}
